// import lottie from '../../scripts/lottie';
import lottie from 'lottie-web';
import animationEnData from './en.json';

const langContainer = document.getElementById('lang-navi');

const params = {
	container: langContainer,
	renderer: 'svg',
	loop: false,
	autoplay: false,
	animationData: animationEnData
};

const langNavi = () => {
	// https://airbnb.io/lottie/#/web?id=usage
	const animation = lottie.loadAnimation(params);

	langContainer.addEventListener('mouseenter', function () {
		animation.playSegments([0, 60], true);
	});
	langContainer.addEventListener('mouseleave', function () {
		animation.playSegments([60, 0], true);
	});
};

const render = () => {
	langNavi();
};

export default render;
